import React, { useMemo } from 'react';

import { Typography, TypographyLink } from '@explorer/core';
import { CoalitionVariant } from '@mui/material';
import ReactMarkdown from 'react-markdown';

/**
 * Markdown
 */
export const Markdown = ({
  md,
  textVariant = 'bodyXS',
  color = 'textSecondary',
}: MarkdownProps) => {
  const renderers = useMemo(
    () => ({
      // eslint-disable-next-line react/no-unstable-nested-components
      paragraph: ({ children }: any) => (
        <Typography variant={textVariant} color={color} pb={0.5}>
          {children}
        </Typography>
      ),
      // eslint-disable-next-line react/no-unstable-nested-components
      link: ({ href, children }: any) => (
        <TypographyLink
          href={href}
          title={href}
          variant={textVariant}
          pb={0.5}
          linkIcon="external"
          newTab
        >
          {children}
        </TypographyLink>
      ),
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return <ReactMarkdown renderers={renderers}>{md}</ReactMarkdown>;
};

/**
 * Markdown Props
 */
export interface MarkdownProps {
  md: string;
  textVariant: CoalitionVariant;
  color?: 'textSecondary' | 'textPrimary' | 'inherit';
}
